<template>
  <div class="sale-page">
    <ApplicationAndReapplyPayment v-if="!isPaymentComplete" @payment-complete="isPaymentComplete = true" />
    <Card v-else>
      <div class="d-flex flex-column align-center justify-center">
        <Logo />
        <ThankYou>
          <template v-slot:title>
            <span class="text-main-color">Thank you!</span>
          </template>
          <template v-slot:text>
            <div class="text-left">
              <p class="mb-3">Your payment was successful.</p>
              <p class="mb-3">We’ll check your details and email you with the next steps.</p>
            </div>
          </template>
        </ThankYou>
      </div>
    </Card>
  </div>
</template>

<script>
import Logo from '@/components/common/Logo/Logo.vue';
import Card from '@/components/common/Card/Card.vue';
import ThankYou from '@/components/common/ThankYou/ThankYou.vue';
import ApplicationAndReapplyPayment from '@/components/common/ApplicationAndReapplyPayment/ApplicationAndReapplyPayment.vue';
export default {
  name: 'ApplicationAndReapplyPaymentPage',
  components: {
    Logo,
    Card,
    ThankYou,
    ApplicationAndReapplyPayment
  },
  data() {
    return {
      isPaymentComplete: false
    };
  }
};
</script>
